import { jsxs as j, jsx as a } from "react/jsx-runtime";
import * as l from "react";
import { u as M, c as H } from "../../../../index-BuoCCRCS.js";
import { u as N, c as A, P as y } from "../../../../index-6KFc9HBo.js";
import { u as U } from "../../../../index-BZPx6jYI.js";
import { u as q } from "../../../../index-B0KnIJcK.js";
import { c as P } from "../../../../clsx-OuTLNxxd.js";
var _ = "Switch", [z, V] = A(_), [F, L] = z(_), R = l.forwardRef(
  (e, n) => {
    const {
      __scopeSwitch: t,
      name: s,
      checked: c,
      defaultChecked: u,
      required: r,
      disabled: o,
      value: h = "on",
      onCheckedChange: b,
      form: d,
      ...S
    } = e, [p, w] = l.useState(null), v = N(n, (f) => w(f)), C = l.useRef(!1), k = p ? d || !!p.closest("form") : !0, [m, T] = M({
      prop: c,
      defaultProp: u ?? !1,
      onChange: b,
      caller: _
    });
    return /* @__PURE__ */ j(F, { scope: t, checked: m, disabled: o, children: [
      /* @__PURE__ */ a(
        y.button,
        {
          type: "button",
          role: "switch",
          "aria-checked": m,
          "aria-required": r,
          "data-state": B(m),
          "data-disabled": o ? "" : void 0,
          disabled: o,
          value: h,
          ...S,
          ref: v,
          onClick: H(e.onClick, (f) => {
            T((I) => !I), k && (C.current = f.isPropagationStopped(), C.current || f.stopPropagation());
          })
        }
      ),
      k && /* @__PURE__ */ a(
        g,
        {
          control: p,
          bubbles: !C.current,
          name: s,
          value: h,
          checked: m,
          required: r,
          disabled: o,
          form: d,
          style: { transform: "translateX(-100%)" }
        }
      )
    ] });
  }
);
R.displayName = _;
var x = "SwitchThumb", E = l.forwardRef(
  (e, n) => {
    const { __scopeSwitch: t, ...s } = e, c = L(x, t);
    return /* @__PURE__ */ a(
      y.span,
      {
        "data-state": B(c.checked),
        "data-disabled": c.disabled ? "" : void 0,
        ...s,
        ref: n
      }
    );
  }
);
E.displayName = x;
var O = "SwitchBubbleInput", g = l.forwardRef(
  ({
    __scopeSwitch: e,
    control: n,
    checked: t,
    bubbles: s = !0,
    ...c
  }, u) => {
    const r = l.useRef(null), o = N(r, u), h = U(t), b = q(n);
    return l.useEffect(() => {
      const d = r.current;
      if (!d) return;
      const S = window.HTMLInputElement.prototype, w = Object.getOwnPropertyDescriptor(
        S,
        "checked"
      ).set;
      if (h !== t && w) {
        const v = new Event("click", { bubbles: s });
        w.call(d, t), d.dispatchEvent(v);
      }
    }, [h, t, s]), /* @__PURE__ */ a(
      "input",
      {
        type: "checkbox",
        "aria-hidden": !0,
        defaultChecked: t,
        ...c,
        tabIndex: -1,
        ref: o,
        style: {
          ...c.style,
          ...b,
          position: "absolute",
          pointerEvents: "none",
          opacity: 0,
          margin: 0
        }
      }
    );
  }
);
g.displayName = O;
function B(e) {
  return e ? "checked" : "unchecked";
}
var D = R, W = E;
const i = {
  "switch-container": "_switch-container_116jj_29",
  "switch-disabled": "_switch-disabled_116jj_35",
  "switch-root": "_switch-root_116jj_35",
  "switch-thumb": "_switch-thumb_116jj_44",
  "switch-label": "_switch-label_116jj_78",
  "switch-title": "_switch-title_116jj_86",
  "switch-with-description": "_switch-with-description_116jj_90",
  "switch-description": "_switch-description_116jj_93"
}, Y = ({
  id: e,
  label: n,
  onChange: t,
  description: s,
  value: c,
  defaultChecked: u,
  name: r,
  disabled: o,
  checked: h
}) => /* @__PURE__ */ j("div", { className: P(i["switch-container"], o && i["switch-disabled"]), children: [
  /* @__PURE__ */ j("label", { className: i["switch-label"], htmlFor: e, children: [
    /* @__PURE__ */ a("span", { className: P(i["switch-title"], s && i["switch-with-description"]), children: n }),
    s && /* @__PURE__ */ a("p", { className: i["switch-description"], children: s })
  ] }),
  /* @__PURE__ */ a(
    D,
    {
      className: i["switch-root"],
      id: e,
      checked: h,
      defaultChecked: u,
      onCheckedChange: t,
      value: c,
      name: r,
      "aria-label": r,
      disabled: o,
      children: /* @__PURE__ */ a(W, { className: i["switch-thumb"] })
    }
  )
] });
export {
  Y as Switch
};
